import { Theme } from '@mui/material/styles';

// ----------------------------------------------------------------------

export default function Backdrop(theme: Theme) {

  return {
    MuiBackdrop: {
      styleOverrides: {
        root: {
          background: [
            `rgba(22, 28, 36, 0.8)`,
            'backdrop-filter: blur(4px)',
          ],
          '&.MuiBackdrop-invisible': {
            background: 'transparent'
          }
        }
      }
    }
  };
}
